import { ReCaptchaProvider } from '#features/form';
import { SignInForm } from './SignInForm';

export const SignIn = () => {
  return (
    <ReCaptchaProvider>
      <SignInForm />
    </ReCaptchaProvider>
  );
};
